import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'

Vue.use(Vuex)
const debug = process.env.NODE_ENV != 'production'

export default new Vuex.Store({
  strict: false,
  state: {
    // 用户基本信息
    user_info: {},
    // 当日的订单数据
    today_orders: {},
    // 点餐页面相关state
    meals: {
      show_shop_detail: false,
      single_meal_info: {},
      busi_id: '',
      busi_name: '',
      dis_id: '',
      // 排单ID
      select_id: ''
    },
    // 头像url
    avatar_url: '',
    // 提示信息数组
    alert_msg_arr: [],
    // 购物车信息
    shopping_cart_data: [],
    // 咖啡购物车信息
    shopping_coffee_data: [],
    // 是否展示购物车
    is_show_shopping_cart: false,
    // 菜品备注数组
    remarks: [],
    // 评论页面所需数据
    comment_need_data: {},
    // 个人信息页面相关state
    user: {
      // 我的订单页面
      order: {
        show_comment_view: false,
        stars: []
      },
      // 个人设置页面
      setting: {
        show_modify_password_view: false
      },
      is_feedback: 1
    }
  },
  getters :{
    shopping_coffee_data:state=>state.shopping_coffee_data
  },
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js